import React from 'react';
import axios from 'axios';
import { View, RefreshControl, Appearance, FlatList } from 'react-native';
import { Note } from 'iconsax-react-native';
import { Text } from 'react-native-paper';
import { usePathname, useLocalSearchParams } from 'expo-router';
import { MotiView } from 'moti';
import { Skeleton } from 'moti/skeleton';
import { MainContext } from '../../../contexts/MainContext';
import Spacer from '../../../components/Spacer/Spacer';
import CustomerCard from '../../../components/cards/CustomerCard/CustomerCard';
 
export default function Page(){
  const myContext = React.useContext(MainContext);
  const pathname = usePathname();
  const { id } = useLocalSearchParams();
  const [pageLoading, setPageLoading] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const [isReflesh, setIsReflesh] = React.useState(false);
  const colorScheme = Appearance.getColorScheme();
  const [data, setData] = React.useState([]);
  const memoizedData = React.useMemo(() => data, [data]);
  const [isEmpty, setIsEmpty] = React.useState(false);
  const [loadMoreIsEmpty, setLoadmoreIsEmpty] = React.useState(false);

  React.useEffect(() => {
    getData();
  }, [pathname])

  const getData = (page = 1) => {
    setPageLoading(true);
    setIsReflesh(true)
    setPage(1);
    axios.all([
      axios.post(`/panel/ads/related-customer/${id}?page=${page}`),
    ])
    .then(axios.spread((response) => {
      if(Object.keys(response.data.data).length === 0) {
        setIsEmpty(true);
      }
      setData(response.data.data);
    }))
    .catch(myContext.handleAxiosError)
    .finally(() => {setPageLoading(false); setIsReflesh(false)});
  }

  const loadmore = (page) => {
    axios.all([
      axios.post(`/panel/ads/related-customer/${id}?page=${page}`),
    ])
    .then(axios.spread((response) => {
      if(Object.keys(response.data.data).length === 0) {
        setLoadmoreIsEmpty(true);
      }
      setData(prev => [...prev, ...response.data.data]);
    }))
    .catch(myContext.handleAxiosError)
    .finally(() => {});
  }

  const renderListItem = React.useCallback((item) => <CustomerCard data={item} />, []);

  const skeletonContent = (isSmall = false) => {
    return (
      <MotiView
        transition={{
          type: 'timing',
        }}
        style={{ flex: 1, justifyContent: 'space-between', paddingVertical: !isSmall ? 16 : 0, paddingHorizontal: !isSmall ? 18 : 0 }}
        animate={{ backgroundColor: colorScheme === 'dark' ? '#000000' : '#ffffff' }}
      >
        <View>
          <Skeleton colorMode={colorScheme} width={'100%'} height={250} />
          <Spacer height={8} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={250} />
          <Spacer height={8} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={250} />
        </View>
      </MotiView>
    );
  }

  if(pageLoading) {
    return skeletonContent();
  } else {
    return (
      <View style={{ flex: 1, backgroundColor: '#fcfcfd' }}>
        <FlatList               
          data={Object.values(memoizedData)}
          contentContainerStyle={{ paddingHorizontal: 18, paddingVertical: 16 }}
          keyExtractor={(item, index) => index.toString()}
          renderItem={({ item }) => renderListItem(item)}
          initialNumToRender={10}
          ListFooterComponent={() => isEmpty ? null : loadMoreIsEmpty ? null : skeletonContent(true)}
          onEndReachedThreshold={.8} 
          ListEmptyComponent={() => (
            <View style={{ marginTop: 32, flex: 1, justifyContent: 'center', alignItems: 'center' }}>
              <Note size="48" color="#292D32" variant="Outline"/>
              <Text style={{ marginTop: 6, fontSize: 14, color: '#5B5E63' }}>نتیجه‌ای پیدا نشد</Text>
            </View>
          )}
          refreshControl = {
            <RefreshControl
              refreshing={isReflesh}
              onRefresh={() => {
                getData();
              }}
            />
          }
          onEndReached={({distanceFromEnd}) => {
            if(distanceFromEnd >= 0) {
              setPage(page + 1);
              loadmore(page + 1);
            }
          }}
        />
      </View>
    );
  }
};